export const NavData = [
  { activeTab: 1, iconName: "fa-user", tittle: "Server info" },
  { activeTab: 2, iconName: "fa-chain-broken", tittle: "Account Credentials" },
  { activeTab: 3, iconName: "fa-group", tittle: "Google Credentials" },
  { activeTab: 4, iconName: "fa-chain-broken", tittle: "Firebase Credentials" },
  { activeTab: 5, iconName: "fa-group", tittle: "Api Keys" },
  { activeTab: 6, iconName: "fa-group", tittle: "Preview" },
];
